import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { ReferenceRateBase } from "__generated__/graphql";

const ReferenceRateBaseSelect = ({ value, onChange }: Omit<SelectProps<ReferenceRateBase, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(ReferenceRateBase)}
			getOptionLabel={(option) => intl.formatMessage({ id: `REFERENCE_RATE_BASE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default ReferenceRateBaseSelect;
